import { useEffect, useMemo, useRef, useState } from "react";
import UserContext from "./UserContext";
import useCommonApi from "../hooks/common-apis";

const UserState = (props) => {
  const [userSpaces, setuserSpaces] = useState([]);
  const [selectedFolderStructure, setselectedFolderStructure] = useState({
    type: "",
    value: "",
    title: "",
    placeholder: "",
    loading: false,
    error: null,
    mainHeading: "",
  });
  const [knowLedgeBaseListGlobal, setknowLedgeBaseListGlobal] = useState([]);
  const [workspaceUpdateTrigger, setWorkspaceUpdateTrigger] = useState(0);
  const contextValue = useMemo(
    () => ({
      userSpaces,
      setuserSpaces,
      selectedFolderStructure,
      setselectedFolderStructure,
      knowLedgeBaseListGlobal,
      setknowLedgeBaseListGlobal,
      workspaceUpdateTrigger,
      setWorkspaceUpdateTrigger,
    }),
    [
      userSpaces,
      setuserSpaces,
      selectedFolderStructure,
      setselectedFolderStructure,
      knowLedgeBaseListGlobal,
      setknowLedgeBaseListGlobal,
      workspaceUpdateTrigger,
      setWorkspaceUpdateTrigger,
    ]
  );
  return (
    <UserContext.Provider value={contextValue}>
      {props?.children}
    </UserContext.Provider>
  );
};
export default UserState;
